import { Component } from "omi";

export class DocBase<Props> extends Component<Props> {
  /**
   * Get the height of the element
   * @returns {number} The height of the element
   */
  public getElementHeight(): number {
    const container = this.shadowRoot?.querySelector("#container");
    if (container == null) {
      return 0;
    }

    const styles = window.getComputedStyle(container);
    const marginTop = parseInt(styles.marginTop, 10) || 0;
    const marginBottom = parseInt(styles.marginBottom, 10) || 0;
    const paddingTop = parseInt(styles.paddingTop, 10) || 0;
    const paddingBottom = parseInt(styles.paddingBottom, 10) || 0;
    const titleHeight = this.shadowRoot?.querySelector("#title")?.clientHeight || 0;

    const fullHeight = container.clientHeight + marginTop + marginBottom + paddingTop + paddingBottom + titleHeight;

    return fullHeight;
  }
}
